import { PropsWithChildren } from "react";
import styles from "./styles/FollowFeedPageItem.module.scss";
import FontAwesome from "../utilities/FontAwesome";
import { transformOrganizationType } from "../../utils/StringUtilities";
import { observer } from "mobx-react";
import ClickableLink from "../utilities/ClickableLink";
import classNames from "classnames";
import moment from "moment/moment";
import useCategoryIcons from "../../hooks/useCategoryIcons";
import { useStores } from "../../stores/useStores";

interface DraftPageItemProps {
  organization: OrganizationTypeOrganization;
}

const ComponentContainer = (
  props: PropsWithChildren<
    DraftPageItemProps & {
      internalDraftPage: boolean;
    }
  >,
) => {
  return (
    <ClickableLink href={`/pages/${props.organization.id}`}>
      {props.children}
    </ClickableLink>
  );
};

const DraftPageItem = observer((props: DraftPageItemProps) => {
  const { organizationStore } = useStores();
  const type = transformOrganizationType(props.organization.type);

  const internalDraftPage =
    props.organization.path.split(".")[1] ===
    organizationStore.organization.path.split(".")[1];

  const icon = useCategoryIcons(props.organization);

  const sectionInfoClassName = classNames({
    [styles.sectionInfo]: true,
    [styles.sectionInfoNoContent]:
      internalDraftPage && props.organization.schoolfeed_items_count === 0,
  });

  return (
    <div className={styles.section}>
      <ComponentContainer {...props} internalDraftPage={internalDraftPage}>
        <div className={sectionInfoClassName}>
          <div className={styles.icon}>{icon}</div>
          <div className={styles.orgContainer}>
            <div className={styles.title}>
              {props.organization.title}
              {!internalDraftPage && (
                <FontAwesome
                  name={"fa-external-link-alt"}
                  prefix={"fas"}
                  className={styles.externalLink}
                  aria-label={"External Link"}
                  title={"External Link"}
                />
              )}
            </div>
            {props.organization.type !== "organization" && (
              <div className={styles.type}>
                {!internalDraftPage && <span>External: </span>}
                {type} - {props.organization.title_organization.title}
              </div>
            )}
            <div className={styles.type}>
              Created:{" "}
              {moment(props.organization.created).format("MMMM DD YYYY")}
            </div>
          </div>
        </div>
      </ComponentContainer>
    </div>
  );
});

export default DraftPageItem;
